import { getOrCreateContentfulClient } from '@graphql/client'
import type { ArticleKind } from '@graphql/hooks/article-page'
import { GetRecentArticlesByKind } from '@graphql/hooks/article-topic-page'
import { TEXT } from '@lib/utils/text'
import { ArticlePageTemplate } from '@page-templates/article-page'
import type { ArticleStaticProps } from '@server/helpers/article'
import { getArticleStaticProps } from '@server/helpers/article'
import { isPrd } from '@shared/util/env'
import { LINK } from '@shared/util/link'
import type { NextPage } from 'next'

const PressArticle: NextPage<ArticleStaticProps> = (props) => (
    <ArticlePageTemplate
        kind={TEXT.press}
        breadcrumbs={[{ text: TEXT.press, link: LINK.press() }]}
        {...props}
    />
)

export const getStaticPaths = async () => {
    const client = getOrCreateContentfulClient(TEXT.press)

    const kind: ArticleKind = 'Press'

    // get popular articles and generate static pages for them
    const { data } = await GetRecentArticlesByKind(client, {
        variables: { kind, count: 25 },
    })

    const paths = data?.articleCollection?.items?.map((article) => ({
        params: { slug: article?.slug },
    }))

    return {
        paths: isPrd() ? paths : [],
        fallback: 'blocking',
    }
}

export const getStaticProps = getArticleStaticProps(TEXT.press)

export default PressArticle
